/**
 * Bootstrap modal
 */
import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    fileSizeWarning: String,
    fileMaxWarning: String,
    maxSize: { type: Number, default: 15 },
    maxFiles: { type: Number, default: 10 },
  };

  static get targets() {
    return ["value", "input"];
  }

  display(evt) {
    let fileName = "No file selected";
    const files = Array.from(evt.target.files);

    if (files.length > 0) {
      const maxBytes = this.maxSizeValue * 1024 ** 2;
      const tooLarge = files.some((file) => file.size > maxBytes);
      const tooMany = this.hasFileMaxWarningValue && files.length > this.maxFilesValue;
      if (tooLarge) {
        alert(
          this.fileSizeWarningValue ||
            `The selected file is too large. ${this.maxSizeValue}MB limit.`,
        );
        evt.target.value = "";
      } else if (tooMany) {
        alert(this.fileMaxWarningValue);
        evt.target.value = "";
      } else {
        fileName = files.map((file) => file.name).join(", ");
      }
    }

    // Update placeholder with selected file name(s)
    if (this.valueTarget.nodeName == "INPUT") {
      this.valueTarget.placeholder = fileName;
    } else {
      this.valueTarget.innerHTML = fileName;
    }
  }

  getFiles() {
    return this.inputTarget.files;
  }

  setFiles(files) {
    this.inputTarget.files = files;
    this.inputTarget.dispatchEvent(new Event("change"));
    this.display({ target: this.inputTarget });
  }
}
